import { agencyPath, createRequestWithComputedFilters, customerPath } from '@/utils/api'
import store from '@/store'
import network from '@/utils/network'

/**
 * Récupère les factures de l'agence
 * @type {function(?{filters?: *, ...opt}): *}
 */
export const fetchAgencyInvoices = createRequestWithComputedFilters(
  async (params) => {
    const slugAgency = store.getters['user/agencySlug']
    const r = await network.post(`agency/${slugAgency}${customerPath()}/fetch/invoices`, params)
    return r.data
  },
  {
    filters: {
      site: 'all',
      customer: 'all'
    }
  })

/**
 * Créé / met à jour une facture
 * @returns {Promise<>}
 */
export const postAgencyInvoice = async (invoice) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/invoice`, invoice)
  return r.data
}

/**
 * Permet de récupérer la prévisualisation d'une facture
 * @returns {Promise<>}
 * @param invoice
 */
export const postInvoicePreview = async (invoice) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/invoice/preview`, invoice)
  return r.data
}

/**
 * Récupère la liste des factures en rappel
 * @returns {Promise<any>}
 */
export const getInvoicesReminds = async () => {
  const r = await network.get(`${agencyPath()}/invoices/reminds`)
  return r.data
}
